/**
 * 大屏模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 大屏中间地图顶部
  {
    name: 'getMarketSubjectStatistics',
    url: '/api/back-end-api/v1/sj-screen/scztqk/market-subject-statistic',
  },
  // 市场主体统计情况
  {
    name: 'getMarketStatistics',
    url: '/api/back-end-api/v1/new-screen/enterprise-marketplace',
    defaultParams: {
      status: 1, // 登记状态 1为“在营（开业）企业、2吊销企业、3、吊销并注销、4注销企业
      year: undefined,
    },
  },
  // 查询数据中包含年份
  {
    name: 'getEnterpriseYear',
    url: '/api/back-end-api/v1/new-screen/enterprise-year',
  },
  // 市场主体地市分布情况
  {
    name: 'getEnterpriseCity',
    url: '/api/back-end-api/v1/new-screen/enterprise-city',
    defaultParams: {
      status: 1, // 登记状态 1为“在营（开业）企业、2吊销企业、3、吊销并注销、4注销企业
      year: undefined,
    },
  },
  // 存续主体年度变化趋势
  {
    name: 'getEnterpriseFiveYear',
    url: '/api/back-end-api/v1/new-screen/enterprise-five-year',
  },
  // 存续主体年度变化趋势
  {
    name: 'getEnterpriseMonth',
    url: '/api/back-end-api/v1/new-screen/enterprise-month',
  },
  // 主体类型统计
  {
    name: 'getEnterpriseType',
    url: '/api/back-end-api/v1/new-screen/enterprise-type',
    defaultParams: {
      year: '',
    },
  },
  // 主体分布情况
  {
    name: 'getEnterpriseIndustries',
    url: '/api/back-end-api/v1/new-screen/enterprise-industries',
    defaultParams: {
      industries: 1,
      status: 1,
      year: undefined,
    },
  },
  // 广东省民营企业迁移分析
  {
    name: 'getEnterpriseMove',
    url: '/api/back-end-api/v1/new-screen/enterprise-move',
    defaultParams: {
      year: '',
    },
  },
  // 企业帮扶统计
  {
    name: 'getVillageEnterprise',
    url: '/api/back-end-api/v1/new-screen/village-enterprise',
    method: 'POST',
  },
  // 广东省万企兴万村行动开展情况查询
  {
    name: 'getVillageList',
    url: '/api/back-end-api/v1/new-screen/village-list',
    defaultParams: {
      year: undefined,
    },
  },
  // 企业经营情况
  {
    name: 'getGdTopIncome',
    url: '/api/back-end-api/v1/new-screen/gd-top-income',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省经济创新活力分析-各市科创企业情况
  {
    name: 'getEntData',
    url: '/api/back-end-api/v1/sj-screen/kc/ent/data',
    defaultParams: {
      dataType: undefined,
      year: undefined,
    },
  },
  // 广东省经济创新活力分析-各市科技经费投入情况
  {
    name: 'getKjjfCity',
    url: '/api/back-end-api/v1/sj-screen/kjjf/city/data',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省经济创新活力分析-各市专利授权情况
  {
    name: 'getZlsqCity',
    url: '/api/back-end-api/v1/sj-screen/zlsq/city/data',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省营商环境评价-一二级指标
  {
    name: 'getYshjOption',
    url: '/api/back-end-api/v1/sj-screen/yshj/data/option',
    defaultParams: {
      dataType: undefined,
      year: undefined,
    },
  },
  // 广东省营商环境评价-年份列表
  {
    name: 'getYshjYearOption',
    url: '/api/back-end-api/v1/sj-screen/yshj/year/option',
    defaultParams: {
      dataType: 0
    },
  },
  {
    name: 'getJjHlYearOption',
    url: '/api/back-end-api/v1/sj-screen/jjhl/year/option',
    defaultParams: {
      dataType: 0
    },
  },
  {
    name: 'getZtYearOption',
    url: '/api/back-end-api/v1/sj-screen/zt/year/option',
    defaultParams: {
      dataType: 0
    },
  },
  {
    name: 'getTyYearOption',
    url: '/api/back-end-api/v1/sj-screen/ty/year/option',
    defaultParams: {
      dataType: 0
    },
  },

  // 广东省营商环境评价-综合评分
  {
    name: 'getYshjData',
    url: '/api/back-end-api/v1/sj-screen/yshj/city/data',
    defaultParams: {
      year: undefined,
    },
  },
    {
        name: 'getYshjDetail',
        url: '/api/back-end-api/v1/sj-screen/yshj/detail/data',
        defaultParams: {
            year: undefined,
        },
    },

    // 广东省营商环境评价-明细指标评分
  {
    name: 'getYshjCity',
    url: '/api/back-end-api/v1/sj-screen/yshj/city/detail',
    defaultParams: {
      dataType: undefined,
      year: undefined,
    },
  },
  // 广东省民营经济税收贡献
  {
    name: 'getSsgxDetail',
    url: '/api/back-end-api/v1/sj-screen/ssgx/detail',
    defaultParams: {},
  },
  // 广东省民营企业履行社会责任
  {
    name: 'getLxshzrDetail',
    url: '/api/back-end-api/v1/sj-screen/lxshzr/detail',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营企业履行社会责任-企业帮扶统计
  {
    name: 'getLxshzrDetailList',
    url: '/api/back-end-api/v1/sj-screen/lxshzr/detail/list',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营企业履行社会责任-企业帮扶统计-项目管理
  {
    name: 'getLxshzrDetailProject',
    url: '/api/back-end-api/v1/sj-screen/lxshzr/detail/project',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营企业履行社会责任-企业帮扶统计-项目详情月报
  {
    name: 'getLxshzrDetailProjectReport',
    url: '/api/back-end-api/v1/sj-screen/lxshzr/detail/project/report',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数-基本概况
  {
    name: 'getScztqkDetail',
    url: '/api/back-end-api/v1/sj-screen/scztqk/detail',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-本年新增/注销-基本概况
  {
    name: 'getScztqkNewlyDetail',
    url: '/api/back-end-api/v1/sj-screen/scztqk/newly/detail',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数-市场主体年度变化趋势
  {
    name: 'getScztqkTrend',
    url: '/api/back-end-api/v1/sj-screen/scztqk/year-trend',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-本年新增/注销-市场主体月度变化趋势
  {
    name: 'getScztqkMoonTrend',
    url: '/api/back-end-api/v1/sj-screen/scztqk/mon-trend',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数/新增/注销-市场主体地市分布情况
  {
    name: 'getScztqkDistribution',
    url: '/api/back-end-api/v1/sj-screen/scztqk/city-distribution',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数/新增/注销-市场主体类型统计
  {
    name: 'getScztqkSubject',
    url: '/api/back-end-api/v1/sj-screen/scztqk/market-subject',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数-市场主体迁移分析
  {
    name: 'getScztqkEntOutIn',
    url: '/api/back-end-api/v1/sj-screen/scztqk/ent-out-in',
    defaultParams: {
      year: undefined,
    },
  },
  // 广东省民营经济市场主体基本情况-累计总数-市场主体迁移分析
  {
    name: 'getEntList',
    url: '/api/back-end-api/v1/sj-screen/kc/ent/list',
    defaultParams: {
      year: undefined,
    },
  },
  {
    name: 'getEntModalOption',
    url: '/api/back-end-api/v1/sj-screen/scztqk/ent/option',
  },
  {
    name: 'getEntModalList',
    url: '/api/back-end-api/v1/sj-screen/scztqk/ent/list',
  },
  {
    name: 'getEntOutInList',
    url: '/api/back-end-api/v1/sj-screen/scztqk/ent-out-in/list',
  },
  // 广东省经济创新活力分析-各市科创企业情况-企业详情
  {
    name: 'getEntDetail',
    url: '/api/back-end-api/v1/sj-screen/kc/ent/detail',
  },
  // 市场主体经营异常信息
  {
    name: 'getBusinessAnomalyStatistics',
    url: '/api/back-end-api/v1/sj-screen/scztqk/business-anomaly-statistics',
  },
];
